var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2459 13.331C17.2697 11.4819 18.2628 9.73223 19.8381 8.76372C18.8443 7.34437 17.1797 6.44446 15.4479 6.39027C13.6007 6.19639 11.8099 7.49558 10.8687 7.49558C9.90917 7.49558 8.45992 6.40952 6.89932 6.44163C4.86514 6.50735 2.96877 7.66387 1.9791 9.44229C-0.148296 13.1255 1.43855 18.5387 3.47642 21.516C4.49601 22.9739 5.68762 24.6024 7.24682 24.5446C8.77258 24.4813 9.34243 23.5717 11.1842 23.5717C13.0088 23.5717 13.5434 24.5446 15.1343 24.5079C16.7715 24.4813 17.803 23.0435 18.7868 21.5718C19.5194 20.533 20.0831 19.3849 20.4571 18.1701C18.533 17.3563 17.2482 15.42 17.2459 13.331Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2411 4.43227C15.1338 3.36064 15.5736 1.98325 15.4671 0.59259C14.1032 0.735833 12.8435 1.38765 11.9387 2.41816C11.054 3.42503 10.5936 4.77819 10.6806 6.11569C12.0449 6.12974 13.3862 5.49559 14.2411 4.43227Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStore);
export default __webpack_public_path__ + "static/media/app_store.2852466444517e12f2eaa2043c77ae59.svg";
export { ForwardRef as ReactComponent };